<template>

  <section class="panel" style="height: calc(100vh - 300px)">
    <h5 class="panel-header">Настройки слайда</h5>
    <div class="panel-content groups-content" id="groups-list">
      <div class="title">
        <label class="form-label">Заголовок слайда</label>
        <textarea class="form-control" rows="2" v-model="layout.title"></textarea>
      </div>
      <div class="red-area" :style="{borderColor: layout.red_area_color||'#ff0000', backgroundColor: (layout.red_area_color||'#ff0000')+'20'}">
        <div class="num">
          <div>
            <label class="form-label">Число</label>
            <input class="form-control" placeholder="число" type="text" v-model="layout.red_area_count">
          </div>
          <div>
            <label class="form-label">Цвет</label>
            <select class="form-control" name="red_area_color" id="red_area_color" key="red_area_color"
                    v-model="layout.red_area_color">
              <option v-for="(color, key) in colors" :value="color">{{ key }}</option>
            </select>
          </div>
        </div>
        <div class="text">
          <label class="form-label">Текст</label>

          <textarea class="form-control" rows="3" v-model="layout.red_area_text"></textarea>
        </div>
      </div>
      <div class="comments">
        <label class="form-label">Основные риски</label>
        <div class="comment" v-for="(comment, index) in layout.comments">
          <div class="num">{{ index + 1 }}</div>
          <PdfRiskComment :comment="comment"
          @update:comment="updateComment(index, $event)"
          ></PdfRiskComment>
          <button class="btn" @click="removeComment(index)"><i class="bi bi-trash text-danger"></i></button>
        </div>
        <button class="btn btn-sm btn-outline-dark" @click="addComment">+ Добавить пункт</button>
      </div>
    </div>
  </section>

</template>

<script>

import PdfRiskComment from "@/views/projects/pdf/components/PdfRiskComment.vue";

export default {
  name: 'PdfLayout',
  components: {PdfRiskComment},
  props: {
    layout: {type: Object, default: {}},
  },
  data() {
    return {
      colors: {
        "Красный": "#ff0000",
        "Зелёный": "#237847",
        "Серый": "#4D4D4D"
      }
    }
  },
  computed: {},
  mounted: function () {


  },
  methods: {
    addComment() {
      if (!this.layout.comments) this.layout.comments = []
      this.layout.comments.push({text: ""})
    },
    removeComment(index) {
      this.layout.comments.splice(index, 1)
    },
    updateComment(index, newComment) {
    this.layout.comments.splice(index, 1, newComment)
  },
  }
}

</script>

<style scoped lang="scss">
.red-area {
  border-radius: 10px;
  border: 1px solid #ff0000;
  padding: 10px;
  background: #ff000020;
  margin-top: 10px;

  .num {
    display: flex;
    justify-content: space-between;
  }

  input {
    width: 150px;
    margin-bottom: 20px;
  }
}

textarea {
  height: auto
}

label {
  font-weight: bold;
}

.comments {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;

  .comment {
    display: flex;
    gap: 10px;
    align-items: start;

    .num {
      background: #ff5656;
      flex: 0 0 auto;
      height: 20px;
      width: 20px;
      text-align: center;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-weight: bold;
      line-height: 14px;
      font-size: 14px;
    }
  }
}
</style>
